import React, { useState, useEffect } from 'react';
import { useTranslation } from '../../../shared/i18n';
import { useDashboard } from '../hooks/useDashboard';
import { Guardians } from './Guardians';

/**
 * GuardiansPage - Standalone page for managing family guardians
 * Only accessible by family owners for adding/removing guardians
 */
export const GuardiansPage = () => {
  const { data, isLoading, error } = useDashboard();
  const { t } = useTranslation();
  const [successMessage, setSuccessMessage] = useState(null);

  // Read flash message from sessionStorage on mount
  useEffect(() => {
    const flash = sessionStorage.getItem('flash_notice');
    if (flash) {
      setSuccessMessage(flash);
      sessionStorage.removeItem('flash_notice');
    }
  }, []);

  if (isLoading) {
    return (
      <div className="bg-light">
        <div className="container py-4">
          <div className="text-center py-5">
            <div className="spinner-border text-primary" role="status">
              <span className="visually-hidden">{t('common.loading')}</span>
            </div>
          </div>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="bg-light">
        <div className="container py-4">
          <div className="alert alert-danger">
            {t('common.error')}: {error.message}
          </div>
        </div>
      </div>
    );
  }

  const { user, family, family_users } = data;
  const isOwner = family_users.some(fu => fu.user_id === user.id && fu.role === 'owner');

  const handleDeleteSuccess = (message) => {
    setSuccessMessage(message);
  };

  return (
    <div className="guardian-dashboard">
      <div className="bg-light">
        <div className="container py-4">
          {/* Page Header */}
          <div className="mb-4">
            <h2 className="h1 fw-bold mb-2">{t('guardians.page.title')}</h2>
            <p className="text-muted">{t('guardians.page.description')}</p>
          </div>

          {/* Success Message */}
          {successMessage && (
            <div className="alert alert-success alert-dismissible fade show" role="alert">
              {successMessage}
              <button
                type="button"
                className="btn-close"
                onClick={() => setSuccessMessage(null)}
                aria-label="Close"
              ></button>
            </div>
          )}

          <div className="row">
            <div className="col-lg-8">
              <Guardians
                family={family}
                familyUsers={family_users}
                currentUserId={user.id}
                isOwner={isOwner}
                t={t}
                onDeleteSuccess={handleDeleteSuccess}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GuardiansPage;
